export default __webpack_public_path__ + "static/media/flow360_logo.33383d3d.svg";